import { useMutation, useQueryClient } from "@tanstack/react-query";
import { approvePublicationRequest } from "../api/publicationRequestsApi";
import { queryKeys } from "../lib/queryKeys";

export function useApprovePublicationRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => approvePublicationRequest(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["publication-requests"] });
      qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
